const translations = {
    lastActivity: 'Last Activity',
    lastEdited: 'Last Edited',
    loading: 'Loading',
    name: 'Name',
    noFields: 'No Fields',
    noMoreFields: 'No More Fields'
};

export default translations;
